<script lang="ts">
  import {
    getJoodMembershipBasedPropertyValue,
    getRandomString,
    isMobileWidth,
    slideOpenAnimation,
  } from '../../../../common/util';
  import { getDataFromAmplienceAsync, parseDataForBrandStory } from '../../services/amplience';
  import BrandStoryCard from './BrandStoryCard.svelte';
  import BrandStoryImage from './BrandStoryImage.svelte';
  import BrandStoryLink from './BrandStoryLink.svelte';
  import BrandStoryTitle from './BrandStoryTitle.svelte';

  export let metaData: any;
  let loaded = false;
  let brandStoryData: any = null; // Initialize with null to ensure we check for existence before using
  const isResponsive = isMobileWidth();
  const brandStoryId = getRandomString('brand_', 20);
  // Async function to load brand story data
  export async function onLoad(): Promise<void> {
    try {
      const amplienceId = getJoodMembershipBasedPropertyValue(
        metaData,
        'amplienceId',
        'blueAmplienceId',
        'goldAmplienceId'
      );

      const res: any = await getDataFromAmplienceAsync(amplienceId);
      brandStoryData = parseDataForBrandStory(res);
      loaded = true;
    } catch (error) {
      console.error('Failed to load brand story data:', error);
      loaded = false;
    }
  }

  let expanded = false;

  function onToggleExpand(event: CustomEvent<boolean>) {
    console.log('onToggleExpand', event);
    const isExpanded = event.detail;
    expanded = isExpanded;
  }
</script>

{#if loaded}
  <section class="brand-story-section">
    <BrandStoryTitle content={{ title: brandStoryData?.title, subTitle: brandStoryData?.subTitle }} />

    {#if brandStoryData?.list?.length}
      <div class="brand-story-item">
        {#each brandStoryData?.list as card, index}
          {#if index === 0}
            <div class="master-story-post">
              <BrandStoryCard content={card} reverseLayout={index % 2 === 0} />
              {#if (brandStoryData?.list?.length > 1 || brandStoryData?.images?.length) && !isResponsive}
                <BrandStoryLink storyId={brandStoryId} isExpanded={expanded} on:toggleExpand={onToggleExpand} />
              {/if}
            </div>
          {:else if index > 0 || brandStoryData?.images?.length}
            <div class="full-story-detail hide" id={brandStoryId} transition:slideOpenAnimation>
              <BrandStoryCard content={card} reverseLayout={index % 2 === 0} />
            </div>
            {#if isResponsive && index === brandStoryData?.list?.length - 1}
              <BrandStoryLink storyId={brandStoryId} isExpanded={expanded} on:toggleExpand={onToggleExpand} />
            {/if}
          {/if}
        {/each}

        {#if brandStoryData?.images?.length}
          <div id={brandStoryId} class="hide">
            <div class="brand-story-image-section">
              <BrandStoryImage content={brandStoryData} />
              {#if isResponsive}
                <BrandStoryLink storyId={brandStoryId} isExpanded={expanded} on:toggleExpand={onToggleExpand} />
              {/if}
            </div>
          </div>
        {/if}
      </div>
    {/if}
  </section>
{/if}

<style lang="scss">
  @import '../../styles/colors.new.scss';
  .brand-story-section {
    background: $primary-white;
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 80px 48px;
    width: 100%;
    @include desktop-max-width {
      padding: 40px 16px;
    }
    .brand-story-item {
      display: flex;
      flex-direction: column;
      gap: 100px;
      @include desktop-max-width {
        gap: 40px;
      }
    }
    .master-story-post {
      display: flex;
      flex-direction: column;
      @include desktop-max-width {
        gap: 15px;
      }
    }
    .brand-story-image-section {
      display: flex;
      flex-direction: column;
      @include desktop-max-width {
        gap: 40px;
      }
    }
  }
</style>
